import {formatDate} from '@angular/common';
import {Injectable} from '@angular/core';
import {AuthService} from '../../services/auth.service';

/** Canonical UI datetime format — matches BE ExportService.format_ui_datetime */
export const REPORTING_DATETIME_FORMAT = 'dd-MM-yyyy hh:mm a';
export const REPORTING_DATE_FORMAT = 'dd-MM-yyyy';
export const REPORTING_TIME_FORMAT = 'hh:mm a';
export const REPORTING_API_DATE_FORMAT = 'yyyy-MM-dd';
export const REPORTING_LOCALE = 'en-IN';
export const DEFAULT_REPORTING_TIMEZONE = 'Asia/Kolkata';

export type ReportingDatePreset = 'datetime' | 'date' | 'time' | 'apiDate';

/**
 * Single source of truth for organization reporting-timezone presentation.
 * Display only — does not change stored UTC timestamps or filter query semantics.
 */
@Injectable({providedIn: 'root'})
export class ReportingDateTimeService {
    constructor(private authService: AuthService) {
    }

    getTimezone(): string {
        const tz = this.authService.getReportingTimezone?.()
            ?? this.authService.getCurrentUserInfo?.()?.timezone;
        return (typeof tz === 'string' && tz.trim()) ? tz.trim() : DEFAULT_REPORTING_TIMEZONE;
    }

    format(
        value: string | number | Date | null | undefined,
        format: string = REPORTING_DATETIME_FORMAT,
    ): string {
        if (value == null || value === '') {
            return '';
        }
        const date = value instanceof Date ? value : new Date(value);
        if (Number.isNaN(date.getTime())) {
            return typeof value === 'string' ? value : '';
        }
        return formatDate(date, format, REPORTING_LOCALE, this.getTimezone());
    }

    formatPreset(
        value: string | number | Date | null | undefined,
        preset: ReportingDatePreset = 'datetime',
    ): string {
        const format =
            preset === 'date' ? REPORTING_DATE_FORMAT
                : preset === 'time' ? REPORTING_TIME_FORMAT
                    : preset === 'apiDate' ? REPORTING_API_DATE_FORMAT
                        : REPORTING_DATETIME_FORMAT;
        return this.format(value, format);
    }
}
